import { Component, EventEmitter, inject, Input, OnInit, Output, PLATFORM_ID } from '@angular/core';
import { ISearchCombinedDTO } from '../../../../models/ISearchCombinedDTO';
import { AuctionListingHorizontalViewComponent } from '../../auction-listing/auction-listing-horizontal-view/auction-listing-horizontal-view.component';
import { AuctionListingVerticalViewComponent } from '../../auction-listing/auction-listing-vertical-view/auction-listing-vertical-view.component';
import { ItemVerticalTemplateComponent } from '../../items/item-vertical-template/item-vertical-template.component';
import { ItemHorizontalTemplateComponent } from '../../items/item-horizontal-template/item-horizontal-template.component';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { SelectButtonModule } from 'primeng/selectbutton';
import { faImage, faList } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { isPlatformBrowser } from "@angular/common";
import { Subscription } from 'rxjs';
import { AuthService } from '../../../../services/authentication/auth.service';
import { IAuctionListing } from '../../../../models/IAuctionListing';
import { CustomBreadcrumbComponent } from '../../custom-breadcrumb/custom-breadcrumb.component';
import { CustomBreadcrumbService } from '../../../../services/custom-breadcrumb/custom-breadcrumb.service';
import { ICustomMenuItem } from '../../../../models/ICustomMenuItem';
import { MenuItem } from 'primeng/api';
import { AbsoluteMediaUriService } from '../../../../services/absolute-media-uri.service';


@Component({
  selector: 'app-search-combined',
  imports: [AuctionListingHorizontalViewComponent,
    AuctionListingVerticalViewComponent,
    ItemVerticalTemplateComponent,
    ItemHorizontalTemplateComponent,
    ButtonModule, CommonModule,
    SelectButtonModule, FontAwesomeModule,
    FormsModule, RouterModule, CustomBreadcrumbComponent
  ],
  templateUrl: './search-combined.component.html',
  styleUrl: './search-combined.component.scss'
})
export class SearchCombinedComponent implements OnInit {

  @Input() searchResult: ISearchCombinedDTO | null = null;
  @Input() query: string | null = null;
  @Output() myAuctionChanged = new EventEmitter<IAuctionListing | null>();


  @Output() favoriteStatus = new EventEmitter<{ isFavorite: boolean, itemId: number }>

  private readonly platformId = inject(PLATFORM_ID);
  private readonly authService = inject(AuthService);
  authSubscription!: Subscription;

  isMobile!: boolean;
  totalResult!: number;



  constructor() {
  }

  faImage = faImage;
  faList = faList;

  protected icons = {
    faImage: faImage,
    faList: faList
  }
  viewMode: 'image' | 'list' = 'list';
  ItemListOptions: any[] = [{ label: 'Image View', value: 'image' }, { label: 'List View', value: 'list' }];

  // breadcrumb
  private readonly customBreadcrumbService = inject(CustomBreadcrumbService);
  private readonly absoluteMediaUriService = inject(AbsoluteMediaUriService);

  itemsBreadcrumb: ICustomMenuItem[] | undefined;
  home!: MenuItem;
  responsiveOptions: any[] = [
    {
      breakpoint: '1300px',
      numVisible: 4
    },
    {
      breakpoint: '575px',
      numVisible: 1
    }
  ];

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {

      this.isMobile = window.innerWidth < 1024;
      if (this.isMobile) {
        this.viewMode = 'image';
      } else {
        this.viewMode = this.viewMode ?? 'list';
      }

      window.addEventListener('resize', () => {
        this.viewMode = window.innerWidth < 1200
          ? 'image'
          : 'list';
      });

      if (this.searchResult) {
        this.totalResult = this.searchResult?.auctionsCount + this.searchResult?.itemsCount;
      }

      this.itemsBreadcrumb = [
        { label: 'BiddingForGood', url: this.absoluteMediaUriService.getAbsoluteMediaUri('/auction/biddingforgood.action') },
        { label: `Search Results (${this.totalResult})` },
      ]
      this.customBreadcrumbService.setItems(this.itemsBreadcrumb);
    }
  }

  onFavoriteChanged(event: { isFavorite: boolean, itemId: number }): void {
    this.favoriteStatus.emit(event);
  }

  onMyAuctionsChanged(myAuction: IAuctionListing | null): void {
    this.myAuctionChanged.emit(myAuction)
  }

}
